module.exports = __webpack_public_path__ + "static/media/mulan-lose.6f937b34.png";